import { css } from "@emotion/react";
import bgSound from "../../assets/sound-on.png";

export const stySoundWrapper = css`
  position: fixed;
  background-color: #a99d87;

  width: 26px;
  height: 26px;
  bottom: 60px;
  transform: translate(-50%, -50%) translate(26px, 0px);
  border-radius: 4px;
  border: 2px solid #a99d87;
  text-align: center;
  line-height: 26px;
  color: #f9f9f9;
  z-index: 2;
  cursor: pointer;

  > .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-image: url(${bgSound});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  > .off {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;
    font-size: 30px;
    color: black;
  }

  @media (min-width: 350px) {
    width: 32px;
    height: 32px;
    line-height: 32px;
    transform: translate(-50%, -50%) translate(30px, 0px);

    > .icon {
      width: 16px;
      height: 16px;
    }
  }
`;
